import { Module } from "wrapper6";
import Glide from '@glidejs/glide';

export default class EventLandingpage extends Module {

	ready(app) {
        
        const SLIDER_CONTAINERS = document.querySelectorAll('.event-landingpage-slider');

        if (SLIDER_CONTAINERS.length > 0) {

            for (let i = 0; i < SLIDER_CONTAINERS.length; i++) {

                const SLIDER_CONTAINER = SLIDER_CONTAINERS[i];
                const GLIDE = SLIDER_CONTAINER.querySelector('.glide');

                if (GLIDE) {
                    
                    // setup slider
                    const SLIDER = new Glide(GLIDE, {
                        type: 'carousel',
                        startAt: 0,
                        perView: 1,
                        gap: 30,
                        // animationDuration: 800
                    });
    
                    // Mount slider
                    SLIDER.mount();

                    for (let i = 0; i < SLIDER_CONTAINER.querySelectorAll('.arrow').length; i++) {
                        const arrow = SLIDER_CONTAINER.querySelectorAll('.arrow')[i];
                        arrow.addEventListener('click', () => {
                            let dir = arrow.getAttribute('data-direction');
                            SLIDER.go(dir);
                        });   
                    }
                }
            }
        }
    }
}